/**
 * "Has this browser given us an email?" One flag, one place.
 *
 * syncToBeehiiv() sets localStorage.emailSubscribed on every signup, and several things read
 * it: the popups stay quiet, the cheat sheet forms turn into a download button, and the gated
 * tabs on compound pages open. It is a soft flag. It lives in this browser only and proves
 * nothing, which is fine for content that is one dismiss click away anyway.
 *
 * markSubscribed() also fires a window event so anything on screen that depends on the flag
 * (lock icons, gates) updates without a reload. useSubscribed() in hooks/ listens for it.
 */
const KEY = "emailSubscribed";
export const SUBSCRIBED_EVENT = "bhg:subscribed";

export function isSubscribed(): boolean {
  try {
    return typeof window !== "undefined" && !!localStorage.getItem(KEY);
  } catch {
    return false;
  }
}

export function markSubscribed(): void {
  try {
    localStorage.setItem(KEY, "true");
  } catch {
    /* private mode: the visitor is asked again next time */
  }
  try {
    window.dispatchEvent(new Event(SUBSCRIBED_EVENT));
  } catch {
    /* no window: nothing is listening */
  }
}
